<template>
	<div>
		<Modal v-model="isShow" footer-hide :width="750">
			<div slot="header"><b>订单中的全部周转物</b></div>
			<div style="padding: 20px;">
				<Form label-position="left">
					<FormItem v-for="(item,index) of turnoverBoxList" :key="index">
						<div style="width: 180px;float: left;height: 50px;line-height: 40px;">
							<Badge :text="item.box_type==1?'押金筐':'周转框'" v-if="item.id">
								{{item.box_title}}
							</Badge>
							<Select size="large" placeholder="称重框" v-model="item.box_id" v-else transfer
							        @on-change="selectTurnoverBoxCallback(item.box_id,index)" style="width: 260px;">
								<Option v-for="item1 in $store.state.allTurnoverBoxs" :value="item1.id" :key="item1.id">
									<span>{{ item1.title }}({{changeUnit(item1.box_weight,"g","斤")}}斤)</span>
								</Option>
							</Select>
						</div>
						<div style="width: 140px;float: left;height: 50px;line-height: 40px;">
							<span v-if="item.box_type==1">预借出数:{{item.box_count}}</span>
						</div>
						<div style="width: 258px;float: left;height: 50px;text-align: center;">
							借出:
							<InputNumber controls-outside size="large" :min="1" v-model="item.real_count"
							             :disabled="item.status>1"/>
							<a style="padding-left: 10px;color: #e13d13" v-if="item.status==1 || item.box_type==2"
							   @click="deleteBox(index)">删除</a>
						</div>
					</FormItem>
				</Form>
			</div>
			<Button size="large" icon="md-add" style="width: 48%;" @click="addTurnoverBox" :disabled="!sortingData.inner_no">
				添加周转物
			</Button>
			<Button size="large" icon="md-checkmark-circle" style="width: 50%;" type="primary" @click="updateOrderTurnoverBox"
			        :disabled="!sortingData.inner_no">
				完成清点
			</Button>
		</Modal>
	</div>
</template>

<script>
	import {changeUnit} from "@/libs/util";
	import {querySortingTurnoverBoxList, updateOrderTurnoverBox} from "@/api/sorting/turnoverBox"

	export default {
		name: "sortingTurnbox",
		props: {
			// 分拣数据
			sortingData: {
				type: Object,
				default: {}
			},
		},
		data() {
			return {
				changeUnit,
				isShow: false,
				// 周转物列表
				turnoverBoxList: [],
				// 删除的id
				deleteIds: []
			};
		},
		methods: {
			// 查询关联称重框
			querySortingTurnoverBoxList() {
				if (!this.sortingData.inner_no) return;
				this.deleteIds = [];
				querySortingTurnoverBoxList({
					rows: 100,
					inner_no: this.sortingData.inner_no,
				}).then(data => {
					if (data.data.code == 1200) {
						this.turnoverBoxList = data.data.data.rows;
					}
				});
			},
			// 删除周转物
			deleteBox(index) {
				if (this.turnoverBoxList[index].id) {
					this.deleteIds.push(this.turnoverBoxList[index].id);
				}
				this.turnoverBoxList.splice(index, 1);
			},
			// 更新商品关联周转物
			updateOrderTurnoverBox() {
				let param = {
					deleteIds: this.deleteIds,
					turnoverBoxList: this.turnoverBoxList,
					sortingData: this.sortingData
				};
				// return console.log(param);
				updateOrderTurnoverBox(param).then(data => {
					if (data.data.code == 1200) {
						this.isShow = false;
						this.$emit("submit", {});
					} else {
						this.$Message.error(data.data.msg)
					}
				});
			},
			showModal() {
				this.isShow = true;
				this.querySortingTurnoverBoxList();
			},
			// 添加周转物
			addTurnoverBox() {
				this.turnoverBoxList.push({box_title: "", box_count: 0, real_count: 1, type: 2, status: 1});
			},
			// 选择周转物回调
			selectTurnoverBoxCallback(id, index) {
				this.turnoverBoxList[index].box_title = this.$store.state.allTurnoverBoxsObj[id].title;
			}
		},
		mounted() {
		},
		destroyed() {
		},
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sortingTurnbox/orderTurnbox.vue